import React from 'react'

import { CepDeclinedIcon, Button } from '@octane/spark'
import ClientApplication from 'api/application/interfaces/ClientApplication'

import {
    Container,
    DeclinedTitle,
    BodyText,
    ButtonContainer,
} from './DecisionResult.styled'

export default function DecisionResultDeclined({
    clientApplication,
}: {
    clientApplication: ClientApplication
}): JSX.Element {
    const isJoint = clientApplication?.application_type === 'J'

    return (
        <Container>
            <CepDeclinedIcon />
            <DeclinedTitle>Declined</DeclinedTitle>
            <BodyText>
                We&apos;re unable to find an eligible program for this
                <br />
                applicant and vehicle.
            </BodyText>
            <ButtonContainer>
                {!isJoint && (
                    <a
                        href={`#/copy-into-new/${clientApplication?.id}/`}
                        data-testid="DecisionResultDeclined-retry-with-coapplicant-button"
                        style={{ width: '100%' }}
                    >
                        <Button fullWidth>Retry with a Co-Applicant</Button>
                    </a>
                )}
                <a
                    href={`#/copy-vehicle/${clientApplication?.id}/`}
                    data-testid="DecisionResultDeclined-retry-with-different-vehicle"
                    style={{ width: '100%' }}
                >
                    <Button variant="primaryOutlined" fullWidth>
                        Retry with a Different Vehicle
                    </Button>
                </a>
            </ButtonContainer>
        </Container>
    )
}
